import { C_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import HCheckArray from "@rf-helper/check-have-value";
import {
  agentAutoCompleteItem,
  agentAutoCompleteItemAdapter
} from "@rf/adapters/autocomplete-items/agentItemAdapters";

const prepareAgentsToClient = (res: IPropertyDetailsResponse) => {
  const infoAgents: { [key: string]: any[] } = {
    associates_type: [],
    agents: []
  };

  if (HCheckArray(res?.agents)) {
    res?.agents.forEach(agent => {
      infoAgents.agents.push(
        agentAutoCompleteItemAdapter({
          id: agent.id,
          name: agent.name,
          picture: agent.picture,
          agencyName: agent.agency_name,
          status: agent.user_status
        }) as agentAutoCompleteItem
      );
    });

    const isCoBroker = res?.agents.some(x => x.pivot.is_no_broker === 0);
    if (isCoBroker && res.agents.length == 1) {
      infoAgents.associates_type.push(C_ASSOCIATES_TYPES.NINGUNO);
    } else if (isCoBroker && res.agents.length > 1) {
      infoAgents.associates_type.push(C_ASSOCIATES_TYPES.CO_BROKER);
    } else {
      infoAgents.associates_type.push(C_ASSOCIATES_TYPES.NO_BROKER);
    }
  }

  return infoAgents;
};

export default prepareAgentsToClient;
